import { FormKey } from '../../enums/formKey';
import { StepKey } from '../../enums/stepKey';
import { StoreContext } from '../../models/store/context';

export const getFormApplianceName = (state: StoreContext) => {
  try {
    const formItemTypeCode = state.form?.[StepKey.APPLIANCE_DETAILS]?.[FormKey.ITEM_CATEGORY];
    const category = state.app.catalogue?.find(
      (cat) =>
        cat.categoryCode === state.form?.[StepKey.APPLIANCE_DETAILS]?.[FormKey.SUPER_CATEGORY],
    );
    return category?.appliances.find((app) => app.applianceCode === formItemTypeCode)
      ?.applianceName;
  } catch (e) {
    console.error('Error selecting appliance name from store', e);
    return undefined;
  }
};
